// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_o4-0";
export var animationContainer = "_o4-1";
export var itemPrice = "_o4-a";
export var itemizedContent = "_o4-9";
export var itemizedHeader = "_o4-7";
export var itemizedRow = "_o4-8";
export var itemizedSection = "_o4-6";
export var modalContent = "_o4-2";
export var orderName = "_o4-3";
export var refundOption = "_o4-4";
export var refundOptionsContainer = "_o4-5";
export var shippingLabel = "_o4-b";
export var totalRow = "_o4-c";